import React, { useCallback, useMemo } from 'react';
import { Selector, Flex, TextInput, Popup, Text } from '@leverege/ui-elements';
import ModelUtil from '@leverege/model-util';
import I18N from '@leverege/i18n';
import S from './LineStyleSelector.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.map.LineStyleSelector');
export default function LineStyleSelector(props) {
  const {
    value: pValue,
    allowCustom = true
  } = props;
  const values = useMemo(() => {
    const data = [{
      name: t('solid'),
      value: 'default'
    }, {
      name: t('longDash'),
      value: 'long-dash'
    }, {
      name: t('shortDash'),
      value: 'short-dash'
    }, {
      name: t('dots'),
      value: 'dot'
    }];
    if (allowCustom) {
      data.push({
        name: t('pattern'),
        value: 'pattern'
      }, {
        name: t('customDashes'),
        value: 'custom'
      });
    }
    return data;
  }, [allowCustom]);
  const value = useMemo(() => {
    if (pValue && pValue.startsWith('line-')) {
      return 'custom';
    }
    return pValue;
  }, [pValue]);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "rowM",
    children: [/*#__PURE__*/_jsx(Selector, {
      ...props,
      value: value,
      values: values
    }), pValue && (pValue === 'custom' || pValue.startsWith('line-')) && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(CustomStyleEditor, {
        ...props
      }), /*#__PURE__*/_jsx(Popup, {
        title: t('help'),
        icon: tIcon('helpIcon', 'fa fa-question-circle fa-fw'),
        children: /*#__PURE__*/_jsx("div", {
          className: S.pad,
          children: /*#__PURE__*/_jsxs(Text, {
            variant: "caption",
            children: [/*#__PURE__*/_jsx("p", {
              children: t('helpMessageLine1')
            }), /*#__PURE__*/_jsx("p", {
              children: t('helpMessageLine2')
            })]
          })
        })
      })]
    })]
  });
}
function CustomStyleEditor(props) {
  const {
    value: pValue,
    onChange: pOnChange
  } = props;
  const onChange = useCallback(evt => {
    if (evt.value) {
      const value = parseArrayFromString(evt.value);
      try {
        ModelUtil.isNumberArray(value);
        pOnChange({
          data: evt.data,
          value: `line-${value.join('-')}`
        });
      } catch (err) {}
    } else {
      pOnChange({
        data: evt.data,
        value: 'custom'
      });
    }
  }, [pOnChange]);
  const value = useMemo(() => {
    if (pValue && pValue.startsWith('line-')) {
      const dashString = pValue.substring(5);
      return dashString;
    }
    return null;
  }, [pValue]);
  return /*#__PURE__*/_jsx(TextInput, {
    ...props,
    acceptKey: acceptKey,
    value: value,
    onChange: onChange
  });
}
const validKeys = '0123456789-';
function acceptKey(evt) {
  if (validKeys.includes(evt.key)) {
    return true;
  }
  return false;
}
function parseArrayFromString(value) {
  if (!value) {
    return null;
  }
  const parts = value.split('-');
  return parts.reduce((prev, curr) => {
    if (curr) {
      prev.push(parseInt(curr));
    }
    return prev;
  }, []);
}